import React from"react";import{NumberInput}from"../../../../fields/NumberInput";export const NumberFilter=props=>React.createElement(NumberInput,props);